import { cn } from "@/lib/utils/utils"
import { VariantProps, cva } from "class-variance-authority"
import { ElementType, HTMLAttributes, ReactNode } from "react"

const textVariants = cva("font-sans", {
  variants: {
    variant: {
      h1: "text-[2.5rem] leading-[1.0] tracking-[-0.04em]",
      h2: "text-[2rem] leading-[1.0] tracking-[-0.04em]",
      h3: "text-[1.25rem] leading-[1.0] tracking-[-0.04em]",
      h4: "text-[1rem] leading-[1.0] tracking-[-0.04em]",
      lead: "text-[1.5rem] leading-[1.2] tracking-[-0.02em]",
      paragraph: "text-[1rem] leading-[1.5] tracking-[-0.01em]",
      small: "text-[0.875rem] leading-[1.5] tracking-[-0.01em]",
      caption: "text-[0.75rem] leading-[1.5] tracking-[-0.01em]",
      blockquote: "border-l-2 pl-6 italic",
      list: "ml-6 list-disc [&>li]:mt-2",
    },
    bold: {
      true: "font-semibold",
    },
  },
  defaultVariants: {
    variant: "paragraph",
    bold: false,
  },
})

export type TextVariant = VariantProps<typeof textVariants>

interface TextProps
  extends Omit<HTMLAttributes<HTMLElement>, "color">,
    TextVariant {
  as?: ElementType
  children?: ReactNode
}

function Text({ className, variant, as, bold, ...props }: TextProps) {
  const Component =
    as ||
    (variant === "h1"
      ? "h1"
      : variant === "h2"
      ? "h2"
      : variant === "h3"
      ? "h3"
      : variant === "h4"
      ? "h4"
      : variant === "list"
      ? "ul"
      : variant === "blockquote"
      ? "blockquote"
      : "p")

  return (
    <Component
      className={cn(
        textVariants({ variant, bold }),
        "text-neutral-900",
        className,
      )}
      {...props}
    />
  )
}

export { Text, textVariants }
